import { PillBadge } from '@platform/components';
import { getCardStatusBadge } from '../../dashboard/my-projects/utils';
import { CardStatusEnum, HubStatusEnum } from '@platform/client/schemas';

const hubStatusToCardStatusMap: Record<HubStatusEnum, CardStatusEnum> = {
  [HubStatusEnum.Matched]: CardStatusEnum.project_active,
  [HubStatusEnum.Connected]: CardStatusEnum.discovery_pending,
  [HubStatusEnum.Complete]: CardStatusEnum.project_complete,
};

export const StatusBadge = ({ status }: { status: HubStatusEnum }) => {
  const badgeProps = getCardStatusBadge(hubStatusToCardStatusMap[status]);
  return (
    <PillBadge size='sm' color={badgeProps.color} variant='plain'>
      {badgeProps.text}
    </PillBadge>
  );
};
